<div class="indicator" [style.width]="value + '%'"></div>